<template>
  <div>
    <oil-cap
        :title="'пользователи системы'.toUpperCase()"
        :buttons="[
                  {
                    route: 'user',
                    name: 'добавить пользователя'
                  }
        ]"
    />
    <oil-table
        :items="users"
        :rowClick="rowClick"
        :keys="[
          {text:'Полное имя',value:'FullName'},
          {text:'Имя пользователя',value:'Username'},
          {text:'Адрес электронной почты',value:'Email'},
          {text:'Роль',value:'Role'},
      ]"
    />
  </div>

</template>

<script>
import {userService} from "@/services/userService";

export default {
  data: () => ({
    users: []
  }),
  components: {
    OilTable: () => import('@/components/helper/oil.table'),
    OilCap: () => import('@/components/helper/oil.cap'),
  },
  async created() {
    const users = await userService.getAll()
    this.users = users.data
    console.log(users.data)
  },
  methods: {
    rowClick({Id}) {
      this.$router.push({
        path: `user/${Id}`,
        replace: true
      })
    }
  }
}
</script>

<style scoped>

</style>